import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../News.module.css';

const NewsSearch = ({ initialQuery, onSearch }) => {
  const [value, setValue] = useState(initialQuery);

  useEffect(() => {
    setValue(initialQuery);
  }, [initialQuery]);

  const handleSubmit = e => {
    e.preventDefault();
    onSearch(value.trim());
  };

  return (
    <form role="search" onSubmit={handleSubmit} className={styles.searchForm}>
      <label htmlFor="news-search" className={styles.searchLabel}>
        <span className="sr-only">Search news</span>
        <input
          id="news-search"
          type="search"
          value={value}
          onChange={e => setValue(e.target.value)}
          placeholder="Search news"
          className={`${styles.searchInput} px-4 py-2 rounded-full border-2 border-dark dark:border-white text-dark dark:text-white font-montserratMedium`}
        />
      </label>
      <button
        type="submit"
        data-part="news-pill"
        data-variant="primary"
        className="px-5 py-2 rounded-full bg-button text-white font-montserratBold"
      >
        Search
      </button>
    </form>
  );
};

NewsSearch.propTypes = {
  initialQuery: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
};

NewsSearch.defaultProps = {
  initialQuery: '',
};

export default NewsSearch;
